/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Reducer for SettingsPositions component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.2
 * @since 1.3.0
 */

import produce from 'immer';

import {
    GET_SETTINGS_POSITIONS_LIST_ACTION,
    GET_SETTINGS_POSITIONS_LIST_FAILURE,
    GET_SETTINGS_POSITIONS_LIST_SUCCESS,
    REMOVE_SETTINGS_POSITION_SUCCESS,
} from './settingsPositionsConstants';
import { ISettingsPositionsItem, TSettingsLabelsActionTypes } from './settingsPositionsTypes';

export interface ISettingsPositionsState {
    error: string;
    isLoading: boolean;
    isLoaded: boolean;
    list: ISettingsPositionsItem[];
    hasMore: boolean;
    search: string;
}

export const initialSettingsPositionsState: ISettingsPositionsState = {
    error: '',
    isLoaded: true,
    isLoading: false,
    list: [],
    hasMore: true,
    search: '',
};

export const settingsPositionsReducer = (state = initialSettingsPositionsState, action: TSettingsLabelsActionTypes) =>
    produce(state, draft => {
        switch (action.type) {
            case GET_SETTINGS_POSITIONS_LIST_ACTION:
                draft.isLoading = true;
                if (action.payload.search) {
                    draft.search = action.payload.search;
                }
                if (action.payload.start) {
                    draft.list = [];
                }
                break;
            case GET_SETTINGS_POSITIONS_LIST_SUCCESS:
                draft.isLoaded = true;
                draft.isLoading = false;
                draft.list = action.payload.positionsList;
                draft.hasMore = action.payload.hasMore;
                break;
            case GET_SETTINGS_POSITIONS_LIST_FAILURE:
                draft.isLoaded = true;
                draft.isLoading = false;
                draft.error = action.payload;
                break;
            case REMOVE_SETTINGS_POSITION_SUCCESS:
                draft.list = draft.list.filter(row => row.id !== action.payload.positionId);
                break;
            default:
                break;
        }
    });
